import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=653a5e65&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=js&"
export * from "./Page2.vue?vue&type=script&lang=js&"
import style0 from "./Page2.vue?vue&type=style&index=0&id=653a5e65&prod&scoped=true&lang=css&"
import style1 from "./Page2.vue?vue&type=style&index=1&id=653a5e65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a5e65",
  null
  
)

export default component.exports